export default {"src":"/_next/static/media/shield.ad7050de.svg","height":25,"width":25};